import { useEffect } from 'react';
import { ModalDesktop } from '@acko-tech/building-blocks.ui.modal';
import { ANIMATIONS, ASSETS } from 'src/common/utils/config';
import { Text } from 'src/international-insurance/styles/checkout';
import lottie from 'lottie-web';
import {
  GradientText,
  GiftAnimation,
  ConfettiAnimation,
  CouponSuccessModalContainer,
  TopConfettiAnimation,
  BottomConfettiAnimation,
} from 'src/international-insurance/styles/couponSuccessModal';

const Index = ({ open, setOpen, coupon, sendEvent = () => {} }) => {
  useEffect(() => {
    let giftAnimation: any;
    let confettiAnimation: any;
    let topConfettiAnimation: any;
    let bottomConfettiAnimation: any;

    if (typeof window !== 'undefined') {
      giftAnimation = document?.getElementById('gift-animation');
      confettiAnimation = document?.getElementById('confetti-animation');
      topConfettiAnimation = document?.getElementById('top-confetti-animation');
      bottomConfettiAnimation = document?.getElementById(
        'bottom-confetti-animation'
      );
    }

    lottie.loadAnimation({
      container: giftAnimation,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: ANIMATIONS.GIFT_BOX || ASSETS.GIFT_BOX,
    });

    lottie.loadAnimation({
      container: confettiAnimation,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: ANIMATIONS.CONFETTI,
    });

    lottie.loadAnimation({
      container: topConfettiAnimation,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: ANIMATIONS.CONFETTI,
    });

    lottie.loadAnimation({
      container: bottomConfettiAnimation,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: ANIMATIONS.CONFETTI,
    });

    if (!!open) sendEvent();

    return () => {
      lottie.destroy();
    };
  }, [open]);

  return (
    <ModalDesktop
      show={open}
      onHide={() => setOpen(false)}
      urlhash=""
      padding={'16px 28px'}
      minWidth={'320px'}
      hideCloseButton={true}
      minHeight={'250px'}
      styles={{ overflow: 'visible', minHeight: 'unset', height: '180px' }}
    >
      <CouponSuccessModalContainer>
        <GiftAnimation id="gift-animation" />
        <ConfettiAnimation id="confetti-animation" />
        <TopConfettiAnimation id="top-confetti-animation" />
        <BottomConfettiAnimation id="bottom-confetti-animation" />
        <GradientText>
          {coupon?.discount
            ? `${coupon?.discount?.unit} ${coupon?.discount?.value} off`
            : coupon?.code}
        </GradientText>
        <Text
          color={'rgb(91, 86, 117)'}
          size={'0.75rem'}
          weight={`400`}
          lineHeight={'1rem'}
          margin={'8px 0 0 0'}
        >
          {'on your premium'}
        </Text>{' '}
        <Text
          color={'rgb(4, 2, 34)'}
          size={'0.875rem'}
          weight={`600`}
          margin={`16px 0 0 0`}
          lineHeight={'1.5rem'}
        >{`${
          coupon?.discount ? `'${coupon?.code}' ` : ''
        }coupon applied`}</Text>
      </CouponSuccessModalContainer>
    </ModalDesktop>
  );
};

export default Index;
